import gradientBg from "../../assets/contact-us-page/ProjectCtaSection.png";
import badgeIcon from "../../assets/contact-us-page/Container.png";
import phoneIcon from "../../assets/contact-us-page/Background.png";
import { siteConfig } from "../../config/site";
import { useInView } from "../../hooks/useInView";

export function ProjectCta() {
  const { ref, inView } = useInView<HTMLDivElement>();

  return (
    <section className="mx-auto w-full max-w-[1290px] px-4 pb-16 sm:pb-20">
      <div
        ref={ref}
        className={`relative flex flex-col items-center gap-4 rounded-[36px] bg-cover bg-center px-6 py-16 text-center sm:px-12 ${inView ? "in-view" : ""}`}
        style={{ backgroundImage: `url(${gradientBg})` }}
      >
        <span className="reveal-scroll delay-1 flex items-center gap-2 rounded-full bg-white/20 px-4 py-2 text-xs font-semibold uppercase tracking-[0.6px] text-white">
          <img src={badgeIcon} alt="" className="h-3 w-3" />
          We're Ready 24/7
        </span>

        <h2 className="reveal-scroll delay-2 max-w-[730px] text-3xl font-bold leading-tight sm:text-4xl">
          <span className="text-white">Have a project in mind? </span>
          <span className="text-[#5eead4]">Let's Talk</span>
        </h2>

        <p className="reveal-scroll delay-3 max-w-[576px] text-base leading-7 text-white/85 sm:text-lg">
          Need quick cash assistance or tailored loan plans? Speak directly
          with our senior financial advisors right now.
        </p>

        {siteConfig.phoneHref ? (
          <a
            href={siteConfig.phoneHref}
            className="reveal-scroll delay-4 mt-2 flex items-center gap-4 rounded-full bg-white px-8 py-4 text-base font-semibold text-brand-purple shadow-[0px_8px_20px_rgba(0,0,0,0.15)] transition-opacity hover:opacity-90"
          >
            {siteConfig.phoneDisplay}
            <img src={phoneIcon} alt="" className="h-8 w-8" />
          </a>
        ) : null}
      </div>
    </section>
  );
}
